/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/solid';
import { useNavigate } from 'react-router-dom';

import * as S from './styles';

export interface IBackArrowCompProps {}

export const BackArrowComp = ({}: IBackArrowCompProps) => {
  const navigate = useNavigate();
  return (
    <div className="d-block mb-4 mb-md-0">
      <ArrowLeftIcon style={S.BackArrowStyle} onClick={() => navigate(-1)} />
    </div>
  );
};

BackArrowComp.defaultProps = {};
